export default "__VITE_ASSET__CQayhc3L__"